const typenumbers = (state = [], action) => {
    switch (action.type) {
      case 'TYPENUMBERS':
      return {
          type: "TYPENUMBERS",
          typenumbers: action.typenumbers
        }
      default:
        return state
    }
  }
  
  export default typenumbers